export default "__VITE_ASSET__BYNgGOL2__"